module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-2-cfce74462596f17dc24f3ee37caf46b3.webp";